import {LitElement, html, css} from 'lit';
import {authService} from '../../auth/auth.service.js';

const COUNTDOWN_SECONDS = 4;

export class ClamSessionExpired extends LitElement {
	static styles = css`
		:host {
			display: flex;
			min-height: 100vh;
			align-items: center;
			justify-content: center;
			background: var(--clam-surface-soft, #f5f6f8);
			font-family: var(--clam-font, 'Inter', system-ui, sans-serif);
			padding: 24px;
			box-sizing: border-box;
		}
		.card {
			background: var(--clam-surface, #fff);
			border-radius: 16px;
			padding: 40px 32px;
			max-width: 420px;
			width: 100%;
			text-align: center;
			box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
		}
		.icon {
			width: 64px;
			height: 64px;
			margin: 0 auto 16px;
			border-radius: 50%;
			background: #fff3cd;
			color: #7a5d00;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 30px;
		}
		h1 {
			font-size: 22px;
			color: var(--clam-text, #222);
			margin: 0 0 8px;
		}
		p {
			font-size: 15px;
			color: var(--clam-text-muted, #6d6e71);
			margin: 0 0 20px;
			line-height: 1.5;
		}
		.countdown {
			font-size: 14px;
			color: var(--clam-text-muted, #898a8c);
			margin-bottom: 16px;
		}
		.countdown b {
			color: var(--clam-primary, #5a9d1e);
			font-size: 16px;
		}
		.btn {
			display: inline-block;
			padding: 12px 28px;
			background: var(--clam-primary, #5a9d1e);
			color: #fff;
			border: none;
			border-radius: 10px;
			font-size: 15px;
			font-weight: 600;
			font-family: inherit;
			cursor: pointer;
			text-decoration: none;
			min-height: 44px;
			line-height: 1.2;
		}
		.btn:hover {
			background: var(--clam-primary-hover, #4c8a18);
		}
	`;

	private _seconds = COUNTDOWN_SECONDS;
	private _timer?: ReturnType<typeof setInterval>;
	private _logoutPromise: Promise<void>;

	constructor() {
		super();
		// Disparar el logout cuanto antes (signOut de Amplify puede tardar por la
		// revocación global). La redirección aguarda a que settle para no llegar al
		// login con un "current user" colgado ("There is already a signed in user").
		this._logoutPromise = authService.logout();
	}

	connectedCallback(): void {
		super.connectedCallback();
		this._timer = setInterval(() => {
			this._seconds -= 1;
			if (this._seconds <= 0) {
				this._goLogin();
			} else {
				this.requestUpdate();
			}
		}, 1000);
	}

	disconnectedCallback(): void {
		if (this._timer) clearInterval(this._timer);
		super.disconnectedCallback();
	}

	private async _goLogin(): Promise<void> {
		if (this._timer) clearInterval(this._timer);
		try { await this._logoutPromise; } catch { /* ignore */ }
		window.location.assign("/login");
	}

	render() {
		return html`
			<div class="card">
				<div class="icon">⏳</div>
				<h1>Tu sesión ha expirado</h1>
				<p>Por seguridad, cerramos tu sesión tras un tiempo de inactividad. Inicia sesión de nuevo para continuar.</p>
				<div class="countdown">Redirigiendo al inicio de sesión en <b>${this._seconds}</b>…</div>
				<a class="btn" href="/login" @click=${(e: Event) => { e.preventDefault(); this._goLogin(); }}>Iniciar sesión ahora</a>
			</div>
		`;
	}
}

customElements.define("clam-session-expired", ClamSessionExpired);
